import React from "react";
import PropTypes from "prop-types";
import cl from "classnames";
import NextPageButton from "./NextPageButton";
import PrevButton from "./PrevPageButton";
import PageList from "./PageList";
import classes from "./styles.module.scss";

export const Pagination = ({
  currentPage,
  loadedPages,
  totalPages,
  query,
  loadPage,
  linkAll,
}) => {
  const hasPrevPage = currentPage > 1;
  const hasNextPage = currentPage < totalPages;
  // console.log('currentPage', currentPage)
  // console.log('loadedPages', loadedPages)
  // console.log('totalPages', totalPages)
  // console.log('query', query)
  // console.log('loadPage', loadPage)
  // console.log('linkAll', linkAll)
  return (
    <nav
      className={cl(classes.SrpPagination, { "srp-page-1": currentPage === 1 })}
    >
      {hasPrevPage && (
        <PrevButton
          currentPage={currentPage}
          onClick={() => loadPage(currentPage - 1)}
          query={linkAll || query}
        />
      )}

      {totalPages > 0 && (
        <PageList
          currentPage={currentPage}
          loadedPages={loadedPages}
          totalPages={totalPages}
          loadPage={loadPage}
          query={linkAll || query}
        />
      )}

      {hasNextPage && (
        <NextPageButton
          currentPage={currentPage}
          onClick={() => loadPage(currentPage + 1)}
          query={linkAll || query}
        />
      )}
    </nav>
  );
};

Pagination.propTypes = {
  currentPage: PropTypes.number.isRequired,
  loadedPages: PropTypes.arrayOf(PropTypes.number).isRequired,
  totalPages: PropTypes.number.isRequired,
  query: PropTypes.object.isRequired,
  loadPage: PropTypes.func.isRequired,
  linkAll: PropTypes.string,
};

export default Pagination;
